<!--
  通用确认弹窗：壳层走 SystemDialog，对外 API 保持不变（open / title / content / footer / card-title）。
-->
<template>
  <SystemDialog
    v-model="dialog"
    persistent
    content-class="confirm-dialog"
    :max-width="maxWidth"
    :show-header="!hasCardTitleSlot"
    :show-close="!hasCardTitleSlot"
    actions-align="center"
    @close="close">
    <template v-if="!hasCardTitleSlot" v-slot:title>
      <slot name="title" :options="formData"></slot>
    </template>

    <!-- 少数弹窗自带完整 header（含关闭），挂在 body 顶部以兼容旧 slot -->
    <div v-if="hasCardTitleSlot" class="confirm-dialog__custom-header">
      <slot name="card-title" :close="close" :options="formData" :ok="ok"></slot>
    </div>

    <div class="confirm-dialog__content">
      <slot></slot>
      <slot name="content" :options="formData">
        {{ formData.content }}
      </slot>
    </div>

    <template v-slot:actions>
      <slot name="footer" :ok="ok" :close="close">
        <v-btn depressed small class="text-none" color="primary" outlined @click="close">
          {{ $t('button.cancel') }}
        </v-btn>
        <v-btn depressed small class="text-none" color="primary" :loading="loading" @click="ok">
          {{ $t('button.confirm') }}
        </v-btn>
      </slot>
    </template>
  </SystemDialog>
</template>

<script>
import loadingMixin from '@/module/mixins/loading.mixin.js'
import SystemDialog from '@/components/SystemDialog.vue'

export default {
  name: 'Confirm',
  components: { SystemDialog },
  mixins: [loadingMixin],
  props: {
    maxWidth: {
      type: [String, Number],
      default: '400px'
    }
  },
  data() {
    return {
      formData: {
        content: ''
      }
    }
  },
  computed: {
    hasCardTitleSlot() {
      return !!(this.$scopedSlots['card-title'] || this.$slots['card-title'])
    }
  },
  methods: {
    open(options) {
      this.formData = Object.assign({}, this.formData, options || {})
      this.dialog = true
    }
  }
}
</script>

<style lang="scss">
.confirm-dialog {
  .system-dialog__title {
    white-space: normal;
    word-break: break-word;
  }

  // 自定义 header 在 body 内：固定标题，只滚内容，避免与 SystemDialog 默认 body 滚动冲突
  .system-dialog__body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  &__custom-header {
    flex-shrink: 0;
    margin: -8px -24px 8px;
  }

  &__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.5;
    color: #6b7280;
    text-align: left;

    p {
      margin: 0;
      font-size: 13px;
      line-height: 1.5;
      color: #6b7280;

      & + p {
        margin-top: 8px;
      }
    }
  }

  // footer 里仍有 v-spacer 的旧写法，用 space-between 兼容
  .system-dialog__actions {
    width: 100%;

    .v-spacer {
      flex-grow: 1 !important;
    }
  }
}
</style>
